import type { WorkerNoteType } from "../../api/workerNotesApi";

export function validateWorkerNoteDuration(
    type: WorkerNoteType,
    durationMinutes: number | null | undefined,
): string | undefined {
    if (type !== "CALL" && type !== "MEETING") return undefined;
    if (durationMinutes === null || durationMinutes === undefined) return undefined;
    if (!Number.isInteger(durationMinutes) || durationMinutes < 1 || durationMinutes > 1440) {
        return "Use a whole number from 1 to 1440";
    }
    return undefined;
}
